module.exports = __webpack_public_path__ + "img/fopea-InsultosX.305382ce.jpg";